import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Pricing from './components/Pricing';
import Schedule from './components/Schedule';
import Events from './components/Events';
import Facility from './components/Facility';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Programs />
      <Pricing />
      <Schedule />
      <Events />
      <Facility />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}